import React from "react"
import { merchantSelectors, PageContainer, PageWrapper, useSelector } from "swiipe.portal.shared"
import DigitealDetailsSectionTechnicalUser from "../../components/digiteal/DigitealDetailsSectionTechnicalUser"
import DigitealDetailsSectionWebhooks from "../../components/digiteal/DigitealDetailsSectionWebhooks"
import "./DigitealDetails.scss"

interface IDigitealDetails {}

export interface IFormModel {
    technicalUserUsername: string
    technicalUserPassword: string
}

const DigitealDetails = ({}: IDigitealDetails) => {
    const merchantDetails = useSelector(merchantSelectors.merchantDetails)

    if (!merchantDetails) {
        return null
    }

    return (
        <PageWrapper>
            <PageContainer id="digiteal">
                <DigitealDetailsSectionTechnicalUser merchantDetails={merchantDetails} />
                <DigitealDetailsSectionWebhooks merchantDetails={merchantDetails} />
            </PageContainer>
        </PageWrapper>
    )
}

export default DigitealDetails
